"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitDeliveryDetailsServer = exports.getSubmitDeliveryDetailsServerMutationOptions = exports.submitDeliveryDetailsServer = exports.useGetDeliveryDetailsServerQueryOptions = exports.getDeliveryDetailsServer = exports.useSubmitDeliveryDetails = exports.useSubmitDeliveryDetailsMutationOptions = exports.useSubmitDeliveryDetailsHook = exports.useGetDeliveryDetailsQueryOptions = exports.useGetDeliveryDetailsHook = void 0;
exports.useGetDeliveryDetails = useGetDeliveryDetails;
exports.useGetDeliveryDetailsServer = useGetDeliveryDetailsServer;
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * Basket API
 * Documentation of the controllers and endpoints used in the basket-service.
 * OpenAPI spec version: deploy-only-ECDEV-5248-939
 */
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const useQueryFetch_1 = require("../../utils/orval/useQueryFetch");
const queryFetch_1 = require("../../utils/orval/queryFetch");
const queryKeyMutator_1 = require("../../utils/orval/queryKeyMutator");
/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */
const useGetDeliveryDetailsHook = () => {
    const getDeliveryDetails = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((params, operationName = 'getDeliveryDetails', options, signal) => {
        return getDeliveryDetails({ url: `/api/buy/delivery`, method: 'GET', params, signal }, Object.assign({ operationName: 'getDeliveryDetails' }, options));
    }, [getDeliveryDetails]);
};
exports.useGetDeliveryDetailsHook = useGetDeliveryDetailsHook;
const useGetDeliveryDetailsQueryOptions = (params, operationName = 'getDeliveryDetails', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/api/buy/delivery`, queryOptions });
    const getDeliveryDetails = (0, exports.useGetDeliveryDetailsHook)();
    const queryFn = ({ signal }) => getDeliveryDetails(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetDeliveryDetailsQueryOptions = useGetDeliveryDetailsQueryOptions;
/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */
function useGetDeliveryDetails(params, operationName = 'getDeliveryDetails', options) {
    const queryOptions = (0, exports.useGetDeliveryDetailsQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * @summary Saves the delivery step on the basket.
 */
const useSubmitDeliveryDetailsHook = () => {
    const submitDeliveryDetails = (0, useQueryFetch_1.useQueryFetch)();
    return (0, react_1.useCallback)((deliveryStepDTO, operationName = 'submitDeliveryDetails', options, signal) => {
        return submitDeliveryDetails({
            url: `/api/buy/delivery`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: deliveryStepDTO,
            signal,
        }, Object.assign({ operationName: 'submitDeliveryDetails' }, options));
    }, [submitDeliveryDetails]);
};
exports.useSubmitDeliveryDetailsHook = useSubmitDeliveryDetailsHook;
const useSubmitDeliveryDetailsMutationOptions = (options) => {
    const mutationKey = ['submitDeliveryDetails'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : Object.assign(Object.assign({}, options), { mutation: Object.assign(Object.assign({}, options.mutation), { mutationKey }) })
        : { mutation: { mutationKey }, request: undefined };
    const submitDeliveryDetails = (0, exports.useSubmitDeliveryDetailsHook)();
    const mutationFn = props => {
        const { data, operationName } = props !== null && props !== void 0 ? props : {};
        return submitDeliveryDetails(data, operationName, requestOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
exports.useSubmitDeliveryDetailsMutationOptions = useSubmitDeliveryDetailsMutationOptions;
/**
 * @summary Saves the delivery step on the basket.
 */
const useSubmitDeliveryDetails = (options) => {
    const mutationOptions = (0, exports.useSubmitDeliveryDetailsMutationOptions)(options);
    return (0, react_query_1.useMutation)(mutationOptions);
};
exports.useSubmitDeliveryDetails = useSubmitDeliveryDetails;
/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */
const getDeliveryDetailsServer = (params, operationName = 'getDeliveryDetails', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/public/checkout/delivery`, method: 'GET', params, signal }, Object.assign({ operationName: 'getDeliveryDetails' }, options));
};
exports.getDeliveryDetailsServer = getDeliveryDetailsServer;
const useGetDeliveryDetailsServerQueryOptions = (params, operationName = 'getDeliveryDetails', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/public/checkout/delivery`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getDeliveryDetailsServer)(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetDeliveryDetailsServerQueryOptions = useGetDeliveryDetailsServerQueryOptions;
/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */
function useGetDeliveryDetailsServer(params, operationName = 'getDeliveryDetails', options) {
    const queryOptions = (0, exports.useGetDeliveryDetailsServerQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * @summary Saves the delivery step on the basket.
 */
const submitDeliveryDetailsServer = (deliveryStepDTO, operationName = 'submitDeliveryDetails', options, signal) => {
    return (0, queryFetch_1.queryFetch)({
        url: `/public/checkout/delivery`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: deliveryStepDTO,
        signal,
    }, Object.assign({ operationName: 'submitDeliveryDetails' }, options));
};
exports.submitDeliveryDetailsServer = submitDeliveryDetailsServer;
const getSubmitDeliveryDetailsServerMutationOptions = (options) => {
    const mutationKey = ['submitDeliveryDetailsServer'];
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : Object.assign(Object.assign({}, options), { mutation: Object.assign(Object.assign({}, options.mutation), { mutationKey }) })
        : { mutation: { mutationKey }, request: undefined };
    const mutationFn = props => {
        const { data, operationName } = props !== null && props !== void 0 ? props : {};
        return (0, exports.submitDeliveryDetailsServer)(data, operationName, requestOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
exports.getSubmitDeliveryDetailsServerMutationOptions = getSubmitDeliveryDetailsServerMutationOptions;
/**
 * @summary Saves the delivery step on the basket.
 */
const useSubmitDeliveryDetailsServer = (options) => {
    const mutationOptions = (0, exports.getSubmitDeliveryDetailsServerMutationOptions)(options);
    return (0, react_query_1.useMutation)(mutationOptions);
};
exports.useSubmitDeliveryDetailsServer = useSubmitDeliveryDetailsServer;
//# sourceMappingURL=basket-service.js.map